import { ModuleFE_PermissionAPI } from './ModuleFE_PermissionAPI.js';
export const ModulePackFE_PermissionAPI = [ModuleFE_PermissionAPI];
//# sourceMappingURL=module-pack.js.map